import { tint } from '../lib/tint';
import type { AuthorSeat, PublicRound } from '../../shared/types';

/**
 * The story, rendered from authoritative state with a subtle background
 * tint per author segment (B5/F-17) and a block caret at the end. Used by
 * the author's writing surface and the moderator preview; the projection
 * uses AnnotatedStory, which adds the margin notes. Scrolling belongs to
 * the surrounding container (see useFollowScroll).
 */
export function StoryText(props: {
  round: PublicRound;
  authors: AuthorSeat[];
  showCaret: boolean;
  className?: string;
}) {
  const { round, authors, showCaret, className } = props;

  const pieces = round.segments.map((seg, i) => {
    const end = round.segments[i + 1]?.start ?? round.text.length;
    const author = authors[seg.author];
    return (
      <span
        key={`${seg.start}-${seg.author}`}
        className="story__segment"
        style={{ background: tint(author?.color ?? '#fff7ec', 0.18) }}
        data-author={seg.author}
      >
        {round.text.slice(seg.start, end)}
      </span>
    );
  });

  const caretColor = authors[round.activeAuthor]?.color ?? '#fff7ec';

  return (
    <div className={`story ${className ?? ''}`} data-testid="story-text">
      {round.text.length === 0 && round.phase !== 'ended' && (
        <span className="story__empty">…</span>
      )}
      {pieces}
      {showCaret && round.phase === 'running' && (
        <span className="story__caret" style={{ background: caretColor }} aria-hidden="true" />
      )}
    </div>
  );
}
